import { render, staticRenderFns } from "./ListKasKecil.vue?vue&type=template&id=4b5757c4&"
import script from "./ListKasKecil.vue?vue&type=script&lang=js&"
export * from "./ListKasKecil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports